import { render, staticRenderFns } from "./AcceptAllInvitation.vue?vue&type=template&id=9740c5c6"
import script from "./AcceptAllInvitation.vue?vue&type=script&lang=js"
export * from "./AcceptAllInvitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports